module.exports = __webpack_public_path__ + "185bb81e5f40dd0c7156f60fcb888970.svg";